import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'zh-Hans',
  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  weekdaysShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'Ah:mm',
    lts: 'Ah:mm:ss',
    L: 'YYYY/M/D',
    LL: 'YYYY[年]M[月]D[日]',
    'LL-D': 'YYYY[年]M[月]',
    'LL-Y': 'M[月]D[日]',
    LLL: 'YYYY[年]M[月]D[日] HH:mm',
    'LLL-Y': 'M[月]D[日] HH:mm',
    LLLL: 'YYYY[年]M[月]D[日] dddd HH:mm',
    'LLLL-Y': 'M[月]D[日] dddd HH:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'YYYY[年]M[月]D[日]',
    'll-Y': 'M[月]D[日]',
    lll: 'YYYY[年]M[月]D[日] Ah:mm',
    'lll-Y': 'M[月]D[日] Ah:mm',
    llll: 'YYYY[年]M[月]D[日] ddd Ah:mm',
    'llll-Y': 'M[月]D[日] ddd Ah:mm',
    'll-Y+w': 'M月D日ddd',
    'LT+to': 'HH:mm([GMT]Z)',
    'LLL+to': 'YYYY年M月D日 HH:mm([GMT]Z)',
  },
  meridiem: { am: '上午', pm: '下午', AM: '上午', PM: '下午' },
  past: {
    y: { other: '%s年前' },
    M: { other: '%s个月前' },
    w: { other: '%s周前' },
    d: { other: '%s天前' },
    h: { other: '%s小时前' },
    m: { other: '%s分钟前' },
    s: { other: '%s秒前' },
  },
  future: {
    y: { other: '%s年后' },
    M: { other: '%s个月后' },
    w: { other: '%s周后' },
    d: { other: '%s天后' },
    h: { other: '%s小时后' },
    m: { other: '%s分钟后' },
    s: { other: '%s秒后' },
  },
  abbr: {
    y: { other: '%s年' },
    M: { other: '%s月' },
    w: { other: '%s周' },
    d: { other: '%s天' },
    h: { other: '%s小时' },
    m: { other: '%s分钟' },
    s: { other: '%s秒' },
  },
  justNow: '刚刚',
  yesterday: '昨天',
  today: '今天',
  tomorrow: '明天',
  weekStart: 1,
};
const localeName: LocaleName = 'zh-Hans';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '上午' : '上午';
    } else {
      return isLowerCase ? '下午' : '下午';
    }
  },
};
